<div class="backdrop" *ngIf="backdropProps" [ngClass]="{ blur: blurProps }"></div>

<app-loading-message class="full-loading__message" size="mini"></app-loading-message>
